import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE, DOMAIN_REGEX } = validations

const domain = {
  name: 'domain',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'O domínio deve ser válido') {
    return this.matches(DOMAIN_REGEX, { message, excludeEmptyString: true })
  },
}

export default domain
